// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"81":"tags","342":"contents","378":"user","903":"games"}[chunkId] + "." + {"81":"414db352","342":"6350eb1d","378":"9f775336","903":"18104ca1"}[chunkId] + ".css";
};